import DocsPage from './DocsPage';

export default DocsPage;
